import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface ActivityDateBadgeProps {
  date: string;
  size?: number;
  sx?: SxProps<Theme>;
}

const ActivityDateBadge: React.FC<ActivityDateBadgeProps> = ({ date, size = 56, sx }) => {
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  const month = parsedDate
    .toLocaleDateString('en-US', { month: 'short' })
    .toUpperCase();
  const day = parsedDate.getDate();

  return (
    <Box
      aria-label={`Event date ${month} ${day}`}
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        border: '1px solid rgba(255, 255, 255, 0.4)',
        boxShadow: '0 12px 24px rgba(0, 0, 0, 0.18)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
        pointerEvents: 'none',
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          letterSpacing: 0.6,
          color: '#FF595E',
          lineHeight: 1,
        }}
      >
        {month}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 800,
          fontSize: `${Math.round(size / 2.2)}px`,
          lineHeight: 1.1,
          color: '#1A1A1A',
        }}
      >
        {day}
      </Typography>
    </Box>
  );
};

export default ActivityDateBadge;

